export default __webpack_public_path__ + "static/jack-7481cde2474468b79cacfa5001cdff0d.jpeg";